import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import RouterAnchorNavLink from "components/links/RouterAnchorNavLink";
import Typography from "@material-ui/core/Typography";
import { fonts } from "theme";
import INavigationItem from "./models/INavigationItem";

const useStyles = makeStyles((theme: Theme) => {
    const spritePositioning = {
        default: 0,
        hover: -33,
        active: -66,
    };

    return createStyles({
        root: {
            color: theme.palette.common.white,
            "&:hover:not($activeNavLink) $sprite": {
                top: spritePositioning.hover,
            },
        },
        activeNavLink: {
            "& $sprite": {
                top: spritePositioning.active,
            },
        },
        label: {
            fontFamily: fonts.secondary,
            fontWeight: 900,
            textTransform: "uppercase",
            padding: "0px 4px",
            visibility: "hidden",
        },
        sprite: {
            position: "absolute",
            width: "100%",
            top: spritePositioning.default,
        },
    });
});

interface IProps extends HTMLAttributes<HTMLElement> {
    item: INavigationItem;
}

export default function NavigationItem(props: IProps) {
    const classes = useStyles();
    const { item, ...rest } = props;
    const { spriteSrc, label, href, matchExactPath = false } = item;

    const clickable = typeof href !== "undefined" && href.length > 0;

    const navItemContent = (
        <ListItemText disableTypography style={{ display: "flex" }}>
            <div style={{ display: "flex", position: "relative", overflow: "hidden" }}>
                <img src={spriteSrc} alt={label} className={classes.sprite} />
                <Typography className={classes.label} variant="h5">
                    {label}
                </Typography>
            </div>
        </ListItemText>
    );

    return (
        <>
            {typeof href !== "undefined" && clickable ? (
                <MenuItem
                    key={label}
                    component={RouterAnchorNavLink}
                    smooth
                    to={href}
                    exact={matchExactPath}
                    className={classes.root}
                    activeClassName={classes.activeNavLink}
                    {...rest}
                >
                    {navItemContent}
                </MenuItem>
            ) : (
                <MenuItem key={label} className={classes.root} disabled {...rest}>
                    {navItemContent}
                </MenuItem>
            )}
        </>
    );
}
